"use client";

import React from "react";
import dynamic from "next/dynamic";
import { CircleCheck } from "lucide-react";

import { Heading, Paragraph } from "@/components/ui/typography";

import AppStore from "@/components/app-store";
import GooglePlay from "@/components/google-play";

import useMoengageEventTracker from "@/hooks/use-moengage";
import EVENT_NAME from "@/hooks/use-moengage/event-name";
import EVENT_ATTRIBUTE from "@/hooks/use-moengage/event-attribute";

const PdpDownloadAppVector = dynamic(
  () => import("@/resources/vector/pdp-download-app.svg")
);

const DownloadAppMobile = dynamic(
  () => import("@/resources/vector/download-app-mobile.svg")
);

const features = [
  "Access Free Learning Content",
  "Get Notified, Stay Ahead",
  "Learn in Your Language",
];

function CourseDownloadApp() {
  const trackMoengageEvent = useMoengageEventTracker();

  const handleDownloadClick = (store) => () => {
    trackMoengageEvent(EVENT_NAME.BUTTON_CLICK, {
      [EVENT_ATTRIBUTE.BUTTON_NAME]: "download_app",
      [EVENT_ATTRIBUTE.STORE]: store,
      [EVENT_ATTRIBUTE.SOURCE_SCREEN]: "pdp",
    });
  };

  return (
    <div className="relative grid grid-cols-2 lg:grid-cols-3 gap-x-4 bg-primary-bg rounded-2xl px-6 md:px-8 overflow-hidden">
      <PdpDownloadAppVector className="absolute left-0 top-0 object-fill size-full" />

      <div className="flex flex-col col-span-2 py-10 z-10">
        <Heading variant="h5" weight="bold">
          With 10 Million students on the app today!
        </Heading>

        <ul className="mt-4 md:mt-8">
          {features.map((feature, index) => (
            <li
              key={index}
              className="flex items-center gap-x-2 mt-2 text-sm text-gray-800"
            >
              <CircleCheck className="size-5 text-primary-foreground fill-primary" />
              <Paragraph variant="b5" className="hidden md:block">
                {feature}
              </Paragraph>
              <Paragraph variant="b4" className="block md:hidden">
                {feature}
              </Paragraph>
            </li>
          ))}
        </ul>

        <div className="flex gap-x-2 md:gap-x-4 mt-6 md:mt-7 lg:w-3/4">
          <AppStore onClick={handleDownloadClick("appstore")} />
          <GooglePlay onClick={handleDownloadClick("playstore")} />
        </div>
      </div>

      <div className="hidden lg:flex col-span-1 items-end justify-end">
        <DownloadAppMobile />
      </div>
    </div>
  );
}

export default CourseDownloadApp;
